import paginateAction from '@utils/paginateAction';
import { courseTypes } from '../constants';
import { paginatorListSchema } from '../schemas';

const getSeeAllEntityType = (id) => {
  if (
    id.toLowerCase() === 'courses' ||
    id.toLowerCase() === 'course' ||
    id === 'courses_big' ||
    id.toLowerCase() === 'programme' ||
    id.toLowerCase() === 'testseries' ||
    id.toLowerCase() === 'test_series'
  )
    return 'course';
  if (id.toLowerCase() === 'topology') return 'topolgy';
  return 'user';
};

const getSeeAllTypeFeed = (key, id, resetWithoutEmpty) => (next) => ({
  type: courseTypes.FETCH_SEE_ALL_FEED,
  endpoint: next,
  method: 'get',
  key,
  resetWithoutEmpty,
  schema: paginatorListSchema,
  directPaginatedEntity: true,
  entityType: getSeeAllEntityType(id)
});

export const fetchSeeAllTypeFeed = (
  goalUid,
  type,
  url,
  id,
  seeAllType,
  nextPage,
  resetWithoutEmpty = false,
  params = ''
) => {
  let finalUrl = url;
  const allParams = `limit=9${params ? `&${params}` : ''}`;
  if (url.includes('?')) {
    finalUrl += `&${allParams}`;
  } else {
    finalUrl += `?${allParams}`;
  }
  const key = `${seeAllType}-${goalUid}-${type}`;
  if (id === 'subjects') {
    return {
      type: courseTypes.GET_ALL_POPULAR_SUBJECTS,
      endpoint: url,
      method: 'get'
    };
  }
  return paginateAction(
    finalUrl,
    getSeeAllTypeFeed(key, id, resetWithoutEmpty),
    'seeAllTypeFeed',
    key,
    resetWithoutEmpty
  )(nextPage);
};

export const fetchFiltersForEducatorList = (blockType, goalUID) => ({
  type: courseTypes.GET_FILTERS_FOR_EDUCATORS_LIST,
  endpoint: `v1/user/browse/educators/block-educators-feed-filters/?block_type=${blockType}&goal_uid=${goalUID}`,
  method: 'get'
});

const getAllSpecialClasses = (subjectUid, resetWithoutEmpty) => (next) => ({
  type: courseTypes.GET_ALL_SPECIAL_CLASSES,
  endpoint: next,
  method: 'get',
  key: subjectUid,
  resetWithoutEmpty,
  schema: paginatorListSchema,
  directPaginatedEntity: true,
  entityType: 'course'
});

export const fetchAllSpecialClasses = (
  subjectUid,
  nextPage,
  resetWithoutEmpty = false
) => {
  return paginateAction(
    `v1/uplus/special_class/topic_group_courses/?topology_uid=${subjectUid}&special_only=True`,
    getAllSpecialClasses(subjectUid, resetWithoutEmpty),
    'allSpecialClasses',
    subjectUid,
    resetWithoutEmpty
  )(nextPage);
};
